module.exports = __webpack_public_path__ + "static/media/lise_virginia_vieira_de_azevedo.5761e2c9.jpg";